/* eslint-disable no-underscore-dangle */
import React, { useState } from "react";

// mui table
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { FaRegFileImage } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { ShowImgStatus } from "../common/ShowImgStatus";
import { getImageFileFetch} from "../../features/action/fetchImage";
import { ShowItem } from "../common/ShowItem";


function TablePrint({ data }) {
  const { image, loadingImage } = useSelector((state) => state.imageFile);
  const [showItems, setShowItems] = useState(false);
  const dispatch = useDispatch();
  const handleOpenImage = (key, url) => {
    setShowItems(key);
    dispatch(getImageFileFetch(url));
  };

  return (
    <TableContainer component={Paper} className="shadow-md h-[350px] overflow-auto">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className="font-semibold">Fabric Name</TableCell>
            <TableCell className="font-semibold">Name File</TableCell>
            <TableCell className="font-semibold">Manager</TableCell>
            <TableCell className="font-semibold">Designer</TableCell>
            <TableCell className="font-semibold">Foto</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {data.map((item,key)=>(item.item.map((i,keyi)=>(
                <TableRow key={i._id}>
                  <TableCell
                    component="th"
                    scope="row"
                    className="font-semibold"
                  >
                    <div className="flex items-center">
                      {item.folderFabric}
                    </div>
                  </TableCell>
                  <TableCell className="font-semibold">{i.fileName}</TableCell>
                  <TableCell className="font-semibold">{i.manager}</TableCell>
                  <TableCell className="font-semibold">
                    {i.designer}
                  </TableCell>
                  <TableCell className="font-semibold">
                    <button
                      className="text-[1vw] text-[#dbdbdb]  content-center "
                      onClick={() => handleOpenImage(keyi, i.image)}
                    >
                      {i.image && <FaRegFileImage />}
                      {showItems === keyi && (
                      <ShowItem url={image} setShowItems={setShowItems} loadingImage={loadingImage}/>
                      )}
                    </button>
                  </TableCell>
                </TableRow>




            ))))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TablePrint;
